'use strict';
const angular = require('angular');

export class testimonialRequestFormComponent {
  /*@ngInject*/
  constructor(MailsService, dialogs, Auth) {

    this.MailsService = MailsService;
    this.dialogs = dialogs;
    this.userId = Auth.getCurrentUserSync()._id;

    this.request = {
      message:'I\'d greatly appreciate if you would give me a testimonial. Thank you.'
    };
  }

  submit() {

    this.MailsService.sendTestimonialRequest({id: this.userId}, this.request, () => {
      this.dialogs.notify("Your testimonial request has been sent","Your testimonial request has been sent.");
      this.dismiss();
    });
  }
}

export default angular.module('conduuApp.testimonialRequestForm', [])
  .component('testimonialRequestForm', {
    template: require('./testimonial-request-form.component.html'),
    bindings: {
      dismiss: '&'
    },
    controller: testimonialRequestFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/testimionial-request-form/testimonial-request-form.component.js